import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";

import SvgImage from "../../../Icons/Icons";

import Toast from "../../../subComponents/toast";
import { toastStatus } from "../../../../services/Store/Actions/appActions";
import Collapsible from "react-collapsible";
import DataTable from "react-data-table-component";
import {
  endTrip,
  getLRList,
  getSavedAddress,
  getTripExpenseAction,
  getTripLedger,
} from "../../../../services/Store/Actions/TripsAction";
import ViewTripCard from "../../../EndTrip/Components/ViewTripCard";
import ViewExpanseCard from "../../../EndTrip/Components/ViewExpanseCard";
import FreightUpdateRender from "../../../EndTrip/Components/FreightUpdateRender";
import { Formik } from "formik";
import { DatePickerField } from "../../../core/inputs/input";
import ManageDriverAddNewExpense from "../../../Modals/ManageDriverAddNewExpense";
import ManageDriverAddBalance from "../../../Modals/ManageDriverAddBalance";
import RechargeFastagButttonModal from "../../../Modals/rechargeFastagButton";
import OMCLoadModal from "../../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/Banners/OMCLoadModal";
import ChooseMethodModal from "../ChooseMethodModal";
import { storeDataToAsyncStorage } from "../../../../services/Utils/functions";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { getAllCustomersAction } from "../../../../services/Store/Actions/customerAction";
function EndTripModal(props) {
  const {
    toggle,
    modal,
    setModal,
    location,
    tripId,
    tripData,
    TripTotalExpenses,
    setItemTemp,
    sattlePayment,
    refreshList,
  } = props;
  const dispatch = useDispatch();
  const [isOpenFASTag, setIsOpenFASTag] = useState(false);
  const [isOpenFuel, setIsOpenFuel] = useState(false);
  const [isVendorExpanse, setIsVendorExpanse] = useState(false);
  const [isOpenCard, setIsOpenCard] = useState(false);
  const [isOpenCash, setIsOpenCash] = useState(false);
  const [view, setView] = useState(false);
  const [openFreight, setOpenFreight] = useState(false);
  const [freightNo, setFreightNo] = useState(null);
  const [openEndTripModal2, setOpenEndTripModal2] = useState(false);
  const [openAddExpanse, setOpenAddExpanse] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [openFuel, setOpenFuel] = useState(false);
  const [open, setOpen] = useState(false);
  const [openChooseMethod, setOpenChooseModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [newFreight, setNewFreight] = useState(false);
  const [newFreightList, setNewFreightList] = useState({});
  const [lrNo, setLrNo] = useState("");
  const [customerOpen, setCustomerOpen] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [search1, setSearch1] = useState("");
  const [search2, setSearch2] = useState("");
  const [display1, setDisplay1] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [color1, setColor1] = useState(-1);
  const [color2, setColor2] = useState(-1);
  const navigate = useNavigate();

  const {
    fastagVehicleTransaction,
    cashTransactions,
    freightList,
    freightListCount,
    tripExpense,
    tripCardLedger,
    tripCardLedgerList,
    tripCardLedgerCount,
    tripFastagLedger,
    tripFastagLedgerList,
    tripFastagLedgerCount,
    tripCashLedger,
    tripCashLedgerList,
    tripCashLedgerCount,
    tripOMCLedger,
    tripOMCLedgerList,
    tripOMCLedgerCount,
    tripVendorLedger,
    tripVendorLedgerList,
    tripVendorLedgerCount,
  } = useSelector((state) => state?.trip);
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const { fastagWallet } = useSelector((state) => state?.fastag);
  const customerList = useSelector((state) => state?.customer?.customerList);
  const customerCount = useSelector((state) => state?.customer?.customerNo);

  useEffect(() => {
    if(props?.setTripExpense){
      dispatch(
        getTripExpenseAction({ tripId: tripData?.tripId }, (res) => {
          if (res?.status == 200) {
            console.log("", res?.data?.data?.trip);
            if (res?.data?.data?.trip) {
              props?.setTripExpense(res?.data?.data?.trip);
            }
          }
        })
      );
    }
  },[])
  const {
    savedAddresses,
    savedAddressCount,
    searchAddresses,
    searchAddressCount,
  } = useSelector((state) => state?.trip);
  const toggleModal3 = () => {
    setOpen3(!open3);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  const rechargeCard = () => {
    setOpen3(true);
  };
  const handleClose4 = () => {
    setOpen4(false);
  };
  const toggleModal4 = () => {
    setOpen4(!open4);
  };
  const closeAddExpense = () => {
    setOpenAddExpanse(false);
  };
  const toggleAddExpense = () => {
    setOpenAddExpanse(!openAddExpanse);
  };
  const loadOmc = () => {
    setOpenFuel(true);
  };
  const handleCloseFuel = () => {
    setOpenFuel(false);
  };
  const toggleModalFuel = () => {
    setOpenFuel(!openFuel);
  };
  const chooseModal = () => {
    setOpenChooseModal(true);
  };
  const handleChooseModal = () => {
    setOpenChooseModal(false);
  };
  const toggleChooseModal = () => {
    setOpenChooseModal(!openChooseMethod);
  };
  const addExpense = () => {
    setOpen(true);
  };
  const handleClose2 = () => {
    setOpen(false);
  };
  const toggleModal2 = () => {
    setOpen(!open);
  };
  const fastagWalletAmount =
    fastagWallet.balance == null ? 0 : fastagWallet.balance;
  // console.log("freightListfreightList", tripData,tripExpense?.gpsData?.odometer);
  const datepickerRefEnd = useRef();
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement?.setOpen(!datepickerElement.open);
  };
  let TotalCashExpacted = 0;
  for (let index = 0; index < tripExpense?.cashData?.length; index++) {
    const element = tripExpense?.cashData?.[index];
    TotalCashExpacted += parseInt(element?.expacted || 0);
  }
  const Expenses = [
    {
      type: "FASTag",
      totalExpenseExpected: tripExpense?.fastagTotal || 0,
      totalExpense: tripExpense?.totalFastagExpense || 0,
      open: () => {
        setIsOpenFASTag(!isOpenFASTag);
        if (!isOpenFASTag) {
          dispatch(
            getTripLedger(tripData?.tripId, {
              mode: "1",
            })
          );
        }
      },
      txns: tripFastagLedgerCount > 0 ? tripFastagLedgerList : [],
      isOpen: isOpenFASTag,
      // pay: () => {
      //   toggleModal4();
      // },
    },
    {
      type: "Fuel",
      totalExpenseExpected: tripExpense?.fuelTotal || 0,
      totalExpense: tripExpense?.totalFuelExpense || 0,
      open: () => {
        setIsOpenFuel(!isOpenFuel);
        console.log("asdfghadsfgesdf");
        if (!isOpenFuel) {
          dispatch(
            getTripLedger(tripData?.tripId, {
              mode: "3",
            })
          );
        }
      },
      txns: tripOMCLedgerCount > 0 ? tripOMCLedgerList : [],
      isOpen: isOpenFuel,
      pay: () => {
        // loadOmc();
        sattlePayment();
        // setIsOpenFuel(!isOpenFuel)
      },
    },
    {
      type: "Vendor",
      totalExpenseExpected: tripExpense?.vendorTotal || 0,
      totalExpense: tripExpense?.totalVendorExpense || 0,
      open: () => {
        setIsVendorExpanse(!isVendorExpanse);
        if (!isVendorExpanse) {
          dispatch(
            getTripLedger(tripData?.tripId, {
              mode: "4",
            })
          );
        }
      },
      txns: tripVendorLedgerCount ? tripVendorLedgerList : [],
      isOpen: isVendorExpanse,
      // pay: () => {
      //   toggleModal4();
      // },
    },
    {
      type: "Card",
      totalExpenseExpected: tripExpense?.driverTotal || 0,
      totalExpense: tripExpense?.totalDriverExpense || 0,
      open: () => {
        setIsOpenCard(!isOpenCard);
        if (!isOpenCard) {
          dispatch(
            getTripLedger(tripData?.tripId, {
              mode: "0",
            })
          );
        }
      },
      txns: tripCardLedgerCount > 0 ? tripCardLedgerList : [],
      isOpen: isOpenCard,
      pay: () => {
        // rechargeCard();
        sattlePayment();
      },
    },
    {
      type: "Cash",
      totalExpenseExpected: TotalCashExpacted || 0,
      totalExpense: tripExpense?.totalCashExpense || 0,
      txns: tripCashLedgerCount > 0 ? tripCashLedgerList : [],
      open: () => {
        setIsOpenCash(!isOpenCash);
        if (!isOpenCash) {
          dispatch(
            getTripLedger(tripData?.tripId, {
              mode: "2",
            })
          );
        }
      },
      isOpen: isOpenCash,
      pay: () => {
        // toggleAddExpense();
        sattlePayment();
      },
    },
  ];

  const handleClose = () => {
    setModal(!modal);
    refreshList();
  };
  useEffect(() => {
    dispatch(
      getAllCustomersAction({
        offset: 0,
        companyName: searchCustomer,
        minKyc: "",
        sortAs: "",
        sortBy: "",
      })
    );
  }, [searchCustomer]);
  const txnListRender = (list) => {
    console.log("txnListRendertxnListRendertxnListRender", list);
    let columns = [];
    list.map((i, k) => {
      console.log(i, k);
      columns = [
        {
          name: "Transaction Date",
          selector: (i) => moment(i.createdAt).format("YYYY-MM-DD HH:mm"),
        },
        {
          name: "Amount",
          selector: (i) => i.amount,
        },
        {
          name: "Type",
          selector: (i) => i.expanseTag,
        },
        {
          name: "Description",
          selector: (i) => i.description,
        },
        // {
        //   name: "Status",
        //   cell: (i) => (
        //     <button
        //       type="button"
        //       // className="btn btn-success"
        //       style={{  }}
        //       // onClick={() => alert("The Trip is Completed")}
        //     >
        //       {i.invoiceId == null ? "UnInvoiced" : "Invoiced"}
        //     </button>
        //   ),
        // },
        // {
        //   name: "Trip",
        //   cell: (i) => (
        //     <button
        //       type="button"
        //       // className="btn btn-success"
        //       style={{  }}
        //       // onClick={() => alert("The Trip is Completed")}
        //     >
        //       {i.tripId == null ? "Unlinked" : "linked"}
        //     </button>
        //   ),
        // },
        {
          // name: "Edit",
          // cell: (i) => (
          //   <button
          //     type="button"
          //     className="btn btn-success"
          //     style={{}}
          //     onClick={() => {
          //       console.log("editLReditLReditLR", i);
          //       setFreightId(i.freightId);
          //       setIsEdit(true);
          //       editLR();
          //     }}
          //     disabled={i?.invoiceId != null}
          //   >
          //     {i?.invoiceId == null ? "" : "invoiced"}
          //   </button>
          // ),
        },
      ];
    });
    return (
      <div>
        <DataTable
          columns={columns}
          data={list}
          highlightOnHover
          onRowClicked={(row) => {}}
        />
      </div>
    );
  };
  let Earnings = 0;
  for (let index = 0; index < freightList?.length; index++) {
    Earnings = Earnings + freightList?.[index]?.freightAmount;
  }
  let Shortage = 0;
  for (let index = 0; index < freightList?.length; index++) {
    Shortage = Shortage + (freightList?.[index]?.shortage || 0);
  }
  let Penalties = 0;
  for (let index = 0; index < freightList?.length; index++) {
    Penalties = Penalties + freightList?.[index]?.charges;
  }
  let lastTrip = new Date(tripData?.expectedEndTime || new Date(null));
  let lastTrip6 = new Date(lastTrip.setHours(lastTrip.getHours() + 6));
  console.log("lastTrip6lastTrip6", tripData, lastTrip6);
  const FreightRender = (freight, i) => {
    console.log("freightRender", freight, i, freightNo);
    return (
      <div>
        <div style={{ marginTop: "2px" }}>
          {freightNo === i ? (
            <FreightUpdateRender
              freight={freight}
              view={view}
              tripId={tripData?.tripId}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (display1 == true) {
      // dispatch(findTripAddressV2({},(res)=>{
      //   console.log("findTripAddressV2",res);
      // }))
      dispatch(
        getSavedAddress({ address: search1 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display1, search1]);
  useEffect(() => {
    if (display2 == true) {
      dispatch(
        getSavedAddress({ address: search2 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display2, search2]);
  useEffect(() => {
    lrNumberFromLastTrip();
  }, [freightList]);
  function lrNumberFromLastTrip() {
    let lrNoString = freightList?.[0]?.lrNo;
    let { number, remainingString } = findNumberAtEnd(lrNoString || "");
    let finalString;
    if (number == null) {
      finalString = 1;
    } else {
      finalString = parseInt(number) + 1;
    }

    console.log("tripNumberFromLastTrip", finalString);
    setLrNo(tripData?.tripNo + "-" + finalString);
    console.log(
      "tripNumberFromLastTrip 2222",
      remainingString + finalString,
      number,
      remainingString
    );
  }
  function findNumberAtEnd(str) {
    const match = str.match(/\d+$/);
    if (match) {
      // Find the position where the number starts
      const numberStartIndex = match.index;
      // Split the string into the part before the number and the number itself
      const remainingString = str.substring(0, numberStartIndex);
      const number = parseInt(match[0], 10);
      return {
        remainingString: remainingString,
        number: number,
      };
    } else {
      // If no number is found at the end, return the original string and null for the number
      return {
        remainingString: str,
        number: null,
      };
    }
  }
  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width-2"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
        scrollable={true}
        centered={true}
        // style={{borderRadius : "10px"}}
      >
        <ModalBody
          className="transactionModalBody"
          style={{ marginTop: "5px" }}
        >
          <div>
            <div className="">
              <div
                className="closeBtnWithBackgroundForTrip"
                onClick={handleClose}
              >
                <SvgImage
                  classname="close-btn-text"
                  style={{ width: "10%", height: "10%" }}
                  name="crossBtnWIthBackground"
                  width="20%"
                  height="20%"
                />
              </div>
              <div className="d-flex">
                <div className="PGCollectiontText col-9" style={{}}>
                  End Trip
                </div>
                <div className="PGCollectiontText col-3" style={{}}></div>
              </div>

              <hr style={{ border: "2px solid #ededf1" }}></hr>
            </div>
            <div
              style={{
                display: "flex",
                // justifyContent: "center",
                gap: "50px",
              }}
            >
              {/* <ViewTripCard tripData={tripData} />
              <ViewExpanseCard
                tripData={tripData}
                tripExpense={{ ...tripExpense, Earnings, Shortage, Penalties }}
              /> */}
            </div>
            {openEndTripModal2 ? (
              <div style={{ paddingTop: "24px" }}>
                <Formik
                  // enableReinitialize
                  initialValues={{
                    endDate: tripData?.expectedEndTime || new Date(),
                    tripRemarks: "",
                    endKmReading: parseInt(tripExpense?.gpsData?.odometer) ||
                      (parseInt(tripData?.startKmReading) +
                        parseInt(tripData?.expectedDistanceKM)) || "",
                    // cardExpanse: tripExpense?.totalDriverExpense || "0",
                    // fastagExpanse: tripExpense?.totalFastagExpense || "0",
                    // cashExpanse: tripExpense?.totalCashExpense || "0",
                    // fuelExpanse: tripExpense?.totalFuelExpense || "0",
                    // vendorExpanse: tripExpense?.totalVendorExpense || "0",
                  }}
                  onSubmit={(values, actions) => {
                    const payload = {
                      tripId: tripData?.tripId,
                      // userId: tripData?.userId,
                      // cardExpanse: values?.cardExpanse || "0.00",
                      // fastagExpanse: values?.fastagExpanse || "0.00",
                      // cashExpanse: values?.cashExpanse || "0.00",
                      // fuelExpanse: values?.fuelExpanse || "0.00",
                      endKmReading:
                        values.endKmReading || tripData?.endKmReading,
                      endTime: values.endDate || tripData?.expectedEndTime,
                      idleReason: values.tripRemarks,
                    };

                    let toggleModalToast = () => {
                      handleClose();
                      // dispatch(
                      //   getTripExpenseAction({ tripId: tripData?.tripId }, (res) => {
                      //     console.log("getTripExpenseAction", res?.data?.data);
                      //     if (res?.data == 200) {
                      //       storeDataToAsyncStorage("row", res?.data?.data?.trip);
                      //       setItemTemp(res?.data?.data?.trip);
                      //     }
                      //   })
                      // );
                      dispatch(
                        toastStatus({
                          toastStatus: false,
                        })
                      );
                      console.log(
                        "nmnnnnnnnnnmmmmppppppp",
                        toastObject?.message
                      );
                    };

                    let handleCloseToast = () => {
                      handleClose();
                      // dispatch(
                      //   getTripExpenseAction({ tripId: tripData?.tripId }, (res) => {
                      //     console.log("getTripExpenseAction", res?.data?.data);
                      //     if (res?.data == 200) {
                      //       storeDataToAsyncStorage("row", res?.data?.data?.trip);
                      //       setItemTemp(res?.data?.data?.trip);
                      //     }
                      //   })
                      // );
                      dispatch(
                        toastStatus({
                          toastStatus: false,
                        })
                      );
                    };
                    console.log("nmnnnnnnnnnmmmmppijihppppp");
                    setLoader(true);
                    dispatch(
                      endTrip(
                        payload,
                        (res) => {
                          setLoader(false);
                          console.log("adsfghaerstdfy4wetry", res?.data);
                        },
                        toggleModalToast,
                        handleCloseToast
                      )
                    );
                  }}
                >
                  {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    values,
                    touched,
                    isValid,
                    errors,
                    setFieldValue,
                  }) => (
                    <Form
                      onSubmit={handleSubmit}
                      style={{ marginLeft: "10px" }}
                    >
                      {console.log("tripDattripDattripDataaa", tripData)}
                      {/* <FormGroup
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          // gap: "40px",
                        }}
                      >
                        <FormGroup style={{ marginTop: "20px" }}>
                          <label className="heading3 semiBold col-12">
                            Fastag Expanse:
                          </label>
                          <div className="custNamepadd3">
                            <input
                              readOnly={true}
                              type="text"
                              id="fastagExpanse"
                              className={`inputBoxCust1 ${
                                touched.fastagExpanse && errors.fastagExpanse
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="fastagExpanse"
                              onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue(
                                  "fastagExpanse",
                                  event.target.value,
                                  true
                                );
                              }}
                              value={values.fastagExpanse}
                              touched={touched.fastagExpanse}
                              errors={errors.fastagExpanse}
                              placeholder="Any Fastag Expanse"
                              autoComplete={"off"}
                            />
                          </div>
                        </FormGroup>

                        <FormGroup style={{ marginTop: "20px" }}>
                          <label
                            for="cardExpanse"
                            className="heading3 semiBold col-12"
                          >
                            Card Expanse:
                          </label>
                          <div className="custNamepadd3">
                            <input
                              readOnly={true}
                              type="text"
                              id="cardExpanse"
                              className={`inputBoxCust1 ${
                                touched.cardExpanse && errors.cardExpanse
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="cardExpanse"
                              onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue(
                                  "cardExpanse",
                                  event.target.value,
                                  true
                                );
                              }}
                              value={values.cardExpanse}
                              touched={touched.cardExpanse}
                              errors={errors.cardExpanse}
                              placeholder="Enter Card Expanse"
                              autoComplete={"off"}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup style={{ marginTop: "20px" }}>
                          <label for="" className="heading3 semiBold col-12">
                            Cash Expanse:
                          </label>
                          <div className="custNamepadd3">
                            <input
                              type="text"
                              readOnly={true}
                              id="cashExpanse"
                              className={`inputBoxCust1 ${
                                touched.cashExpanse && errors.cashExpanse
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="cashExpanse"
                              onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue(
                                  "cashExpanse",
                                  event.target.value,
                                  true
                                );
                              }}
                              value={values.cashExpanse}
                              touched={touched.cashExpanse}
                              errors={errors.cashExpanse}
                              placeholder="Enter Cash Expanse"
                              autoComplete={"off"}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup style={{ marginTop: "20px" }}>
                          <label for="" className="heading3 semiBold col-12">
                            Fuel Expanse:
                          </label>
                          <div className="custNamepadd3">
                            <input
                              type="text"
                              readOnly={true}
                              id="fuelExpanse"
                              className={`inputBoxCust1 ${
                                touched.fuelExpanse && errors.fuelExpanse
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="fuelExpanse"
                              onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue(
                                  "fuelExpanse",
                                  event.target.value,
                                  true
                                );
                              }}
                              value={values.fuelExpanse}
                              touched={touched.fuelExpanse}
                              errors={errors.fuelExpanse}
                              placeholder="Enter Fuel Expanse"
                              autoComplete={"off"}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup style={{ marginTop: "20px" }}>
                          <label for="" className="heading3 semiBold col-12">
                            Vendor Expanse:
                          </label>
                          <div className="custNamepadd3">
                            <input
                              type="text"
                              readOnly={true}
                              id="vendorExpanse"
                              className={`inputBoxCust1 ${
                                touched.vendorExpanse && errors.vendorExpanse
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="vendorExpanse"
                              onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue(
                                  "vendorExpanse",
                                  event.target.value,
                                  true
                                );
                              }}
                              value={values.vendorExpanse}
                              touched={touched.vendorExpanse}
                              errors={errors.vendorExpanse}
                              placeholder="Enter Vendor Expanse"
                              autoComplete={"off"}
                            />
                          </div>
                        </FormGroup>
                      </FormGroup> */}
                      <FormGroup
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FormGroup style={{ marginRight: "50px" }}>
                          <label className="heading3 semiBold">End Date</label>
                          <div
                            className="custNamepadd3 row"
                            style={{ width: "200px" }}
                          >
                            <div className="col-9">
                              <DatePickerField
                                classname="inputBoxCust1"
                                name="endDate"
                                showTimeInput={true}
                                header="Select End date"
                                value={values.endDate}
                                onChange={(v) => {
                                  console.log("v enddate", v);
                                  setFieldValue("endDate", v, true);
                                }}
                                //onChange={(v) => setFieldValue("endDate", v, true)}
                                minDate={
                                  values.startDate === ""
                                    ? ""
                                    : values.startDate
                                }
                                style={{ width: "100px" }}
                                ref={datepickerRefEnd}
                              />
                            </div>
                            <div className="col-3">
                              <label
                                className="date-input"
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleClickDatepickerIcon2();
                                }}
                              >
                                <SvgImage
                                  name="CalenderLogo"
                                  width="32"
                                  height="32"
                                  // classname="date-logo"
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className="heading4 Regular"
                            style={{ margin: "7px 0 0px 0", color: "red" }}
                          >
                            {errors.endDate && touched.endDate ? (
                              <div>*{errors.endDate}</div>
                            ) : null}
                          </div>
                        </FormGroup>
                        {tripData?.userId ? (
                          <FormGroup style={{ marginLeft: "50px" }}>
                            <label className="heading3 semiBold col-12">
                              End Km Reading:
                            </label>
                            <div className="custNamepadd3">
                              <input
                                type="number"
                                id="endKmReading"
                                className={`inputBoxCust1 ${
                                  touched.endKmReading && errors.endKmReading
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="endKmReading"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "endKmReading",
                                    event.target.value,
                                    false
                                  );
                                }}
                                value={values.endKmReading}
                                touched={touched.endKmReading}
                                errors={errors.endKmReading}
                                placeholder="Enter End Km Reading"
                                autoComplete={"off"}
                              />
                            </div>
                          </FormGroup>
                        ) : (
                          <></>
                        )}

                        {values.endDate > lastTrip6 ? (
                          <FormGroup style={{ marginLeft: "50px" }}>
                            <label className="heading3 semiBold col-12">
                              Trip Delayed Reason:
                            </label>
                            <div className="custNamepadd3">
                              <input
                                type="text"
                                id="tripRemarks"
                                className={`inputBoxCust1 ${
                                  touched.tripRemarks && errors.tripRemarks
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  width: "400px",
                                }}
                                name="tripRemarks"
                                onChange={(event) => {
                                  // setSearch(event.target.value);
                                  setFieldValue(
                                    "tripRemarks",
                                    event.target.value,
                                    false
                                  );
                                }}
                                value={values.tripRemarks}
                                touched={touched.tripRemarks}
                                errors={errors.tripRemarks}
                                placeholder="Enter Trip Delayed Reason"
                                autoComplete={"off"}
                              />
                            </div>
                          </FormGroup>
                        ) : null}
                      </FormGroup>

                      <FormGroup
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div className="row">
                          <div
                            style={{
                              textAlign: "left",
                              display: openEndTripModal2 ? "block" : "none",
                              width: "40%",
                              marginRight: "18%",
                            }}
                          >
                            <button
                              // className="btn-edit-details"
                              // style={{ marginLeft: "20px" }}
                              style={{
                                width: "200px",
                                marginTop: "25px",
                              }}
                              className="generateOtp text3 Medium btn btn-secondary"
                              onClick={() => {
                                setOpenEndTripModal2(!openEndTripModal2);
                              }}
                            >
                              <text style={{ color: "white" }}>
                                {openEndTripModal2 ? "Previous" : "Next"}
                              </text>
                            </button>
                          </div>
                          <div style={{ textAlign: "right", width: "40%" }}>
                            <Button
                              type="submit"
                              style={{
                                width: "200px",
                                marginTop: "25px",
                              }}
                              className="generateOtp text3 Medium btn btn-secondary"
                              disabled={loader}
                            >
                              {loader ? (
                                <>
                                  <ClipLoader
                                    // color={"#fff"}
                                    loading={true}
                                    size={20}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                  />
                                </>
                              ) : (
                                "End Trip"
                              )}
                            </Button>
                          </div>
                        </div>
                      </FormGroup>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : (
              <div>
                <h3 style={{ textAlign: "center" }}>Upload PODs</h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "40px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    textAlignLast: "center",
                    background: "#ededf1",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  <td style={{ width: "20%" }}>Lr No.</td>
                  <td style={{ width: "20%" }}>Source</td>
                  <td style={{ width: "20%" }}>Destination</td>
                  <td style={{ width: "25%" }}>Start Date</td>
                  <td style={{ width: "20%" }}>Amount</td>
                  <td style={{ width: "20%" }}>Weight</td>
                  <td style={{ width: "20%" }}>Pay By</td>
                  <td style={{ width: "20%" }}>{}</td>
                </div>
                {freightList.map((elem, i) => {
                  console.log("elelemeelemm", elem);
                  const payBy =
                    elem.customerId == elem.customerId
                      ? elem.consignorName
                      : elem.customerId == elem.consigneeId
                      ? elem.consigneeName
                      : elem.transportorName;
                  return (
                    <div>
                      <Collapsible
                        trigger={
                          <div
                            className=""
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              height: "50px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              textAlignLast: "center",
                              fontSize: "16px",
                            }}
                            onClick={() => {
                              setFreightNo(i);
                              setView(false);
                            }}
                          >
                            <td
                              style={{
                                width: "20%",
                                cursor: "pointer",
                                textDecorationLine: "underline",
                                color: "blue",
                              }}
                              onClick={(e) => {
                                console.log("ddddkooooo", elem);
                                navigate(`/lr/${elem?.freightId}`, {
                                  state: {
                                    lr: elem,
                                    fleetId: elem?.fleetId,
                                    driverId: elem?.userId,
                                    tripNo: elem?.tripId,
                                    lrNo: elem?.lrNo,
                                    startTime: moment(elem?.startDate).format(
                                      "MM/DD/YYYY"
                                    ),
                                    endTime: moment(elem?.endDate).format(
                                      "MM/DD/YYYY"
                                    ),
                                    source: elem?.fromAddress,
                                    destination: elem?.toAddress,
                                    freightId: elem?.freightId,
                                  },
                                });
                              }}
                            >
                              {elem?.lrNo}
                            </td>
                            <td
                              style={{ width: "20%", wordBreak: "break-all" }}
                            >
                              {elem?.fromAddress?.cityName}
                            </td>
                            <td
                              style={{ width: "20%", wordBreak: "break-all" }}
                            >
                              {elem?.toAddress?.cityName}
                            </td>
                            <td style={{ width: "25%" }}>{elem?.startDate}</td>
                            <td style={{ width: "20%" }}>
                              {elem?.freightAmount}
                            </td>
                            <td style={{ width: "20%" }}>{elem?.weight}</td>
                            <td style={{ width: "20%" }}>{payBy}</td>
                            <td style={{ width: "20%" }}>
                              {/* <button 
                        style={{width: "60px", height:"25px",borderRadius: "5px",backgroundColor: "#FFF",borderColor: "#2E7C7B",}}
                        onClick={() => {
                          console.log("onClickonClickonClick")
                          setIsOpen(!isOpen)}}
                      >
                      <text>View</text>
                      </button> */}
                      <div className="d-flex">
                      <button
                                style={{
                                  // width: "60px",
                                  // height: "25px",
                                  borderRadius: "5px",
                                  backgroundColor: "#FFF",
                                  borderColor: "#e9e9e9",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  setFreightNo(i);
                                  setView(false);
                                }}
                              >
                                <SvgImage
                                  name="AddAttachment"
                                  height="20"
                                  width="20"
                                />
                                <div style={{ marginLeft: "6px" }}>POD</div>
                              </button>
                              {elem?.status == 12 ? (
                                <SvgImage name="circleTick" />
                              ) : elem?.status == 11 ? (
                                "Reported"
                              ) : ""}
                      </div>

                            </td>
                          </div>
                        }
                        // triggerSibling="hskdg shkdg"
                        // onOpening={}
                      >
                        <div style={{ margin: "10px" }}>
                          {/* <FreightRender elem={elem} i={i} /> */}

                          <div style={{ marginTop: "2px" }}>
                            {freightNo === i ? (
                              <FreightUpdateRender
                                freight={elem}
                                view={view}
                                tripId={tripData?.tripId}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </Collapsible>
                    </div>
                  );
                })}
                <hr style={{ border: "2px solid #ededf1" }}></hr>
                {newFreight ? (
                  <Formik
                    // isValid='true'
                    enableReinitialize
                    initialValues={{
                      // freightId: freight ? freight?.freightId : "",
                      // podUrl: freight ? freight.podUrl : null,
                      lrNo: lrNo || "",
                      sourceAddress: tripData?.sourceAddress
                        ? tripData?.sourceAddress?.cityName +
                          "-" +
                          tripData?.sourceAddress?.stateName
                        : "",
                      destAddress: tripData?.destAddress
                        ? tripData?.destAddress?.cityName +
                          "-" +
                          tripData?.destAddress?.stateName
                        : "",
                      startDate: tripData
                        ? tripData?.startTime || tripData?.expectedStartTime
                        : "",
                      vrn: tripData ? tripData?.Fleet?.regNumber : "",
                      driver: tripData ? tripData?.User?.fullName : "",
                      fleetId: tripData ? tripData?.fleetId : "",
                      userId: tripData?.userId ? tripData?.userId : "",
                      source: tripData
                        ? tripData?.sourceAddress?.addressId
                        : "",
                      destination: tripData
                        ? tripData?.destAddress?.addressId
                        : "",

                      customerName: "",
                      customerId: "",
                      payorType: "",
                      freightAmount: "",
                      weight: "",
                      lrUrl: "",
                    }}
                  >
                    {({
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                      resetForm,
                      values,
                      touched,
                      isValid,
                      errors,
                      setFieldTouched,
                    }) => (
                      <Form style={{}}>
                        <div>
                          {/* <Collapsible
                            trigger={ */}
                          <div
                            className=""
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              height: "50px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              textAlignLast: "center",
                              fontSize: "16px",
                            }}
                            onClick={() => {
                              // setFreightNo(i);
                              setView(false);
                            }}
                          >
                            <td
                              style={{
                                width: "20%",
                                cursor: "pointer",
                                textDecorationLine: "underline",
                                color: "blue",
                              }}
                            >
                              {/* {elem?.lrNo} */}
                              <input
                                type="text"
                                className="minBox3"
                                name="lrNo"
                                value={values?.lrNo || ""}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)
                                  setFieldValue(
                                    "lrNo",
                                    event.target.value,
                                    false
                                  );
                                }}
                              />
                            </td>
                            <td
                              style={{
                                width: "20%",
                                wordBreak: "break-all",
                              }}
                            >
                              {/* {elem?.fromAddress?.cityName} */}
                              <input
                                type="text"
                                className="minBox3"
                                name="sourceAddress"
                                value={values?.sourceAddress || ""}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)

                                  setDisplay1(true);
                                  setSearch1(event.target.value);
                                  setFieldValue(
                                    "sourceAddress",
                                    event.target.value,
                                    true
                                  );
                                }}
                                onClick={() => {
                                  setDisplay1(true);
                                }}
                              />
                              {display1 ? (
                                <div
                                  className="padding16 newCashback whiteBackground"
                                  style={{
                                    position: "absolute",
                                    width: "350px",
                                    height: "275px",
                                    zIndex: "90",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      setDisplay1(false);
                                      // setSearch1("");
                                      //dispatch(clearAllDriversByVrn());
                                      // setFieldValue("sourceAddress", "", true);
                                    }}
                                    style={{
                                      position: "absolute",
                                      right: "0.5rem",
                                      top: "0.5rem",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <SvgImage name="CloseButtonLogo" />
                                  </div>
                                  <div
                                    style={{
                                      overflowY: "scroll",
                                      overflowX: "hidden",
                                      height: "240px",
                                    }}
                                  >
                                    {console.log(
                                      "savedAddresses11111",
                                      search1,
                                      savedAddresses
                                    )}
                                    {search1 == "" ? (
                                      savedAddresses?.map((data, i) => {
                                        let city = data?.cityName;
                                        let state = data?.stateName;
                                        let address = data?.address;
                                        console.log("savedAddresses", data);
                                        return (
                                          <div
                                            key={i}
                                            className="padding8 row"
                                            onClick={() => {
                                              // setcityId1(data?.cityName);
                                              setColor1(i);
                                              setDisplay1(false);
                                              setFieldValue(
                                                "sourceAddress",
                                                city
                                              );
                                              setTimeout(() =>
                                                setFieldTouched(
                                                  "sourceAddress",
                                                  true
                                                )
                                              );
                                              //setUserId(data?.User?.userId);
                                              setFieldValue(
                                                "source",
                                                data?.addressId
                                              );
                                              setTimeout(() =>
                                                setFieldTouched("source", true)
                                              );
                                            }}
                                          >
                                            {color1 === i ? (
                                              <div className="col-1">
                                                <SvgImage name="SelectedRadio" />
                                              </div>
                                            ) : (
                                              <div className="col-1">
                                                <SvgImage name="UnselectedRadio" />
                                              </div>
                                            )}
                                            {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                            <div
                                              className="col-11"
                                              style={{ textAlign: "left" }}
                                            >
                                              {city} - {address}
                                            </div>
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <>
                                        {savedAddresses?.map((data, i) => {
                                          let city = data?.cityName;
                                          let state = data?.stateName;
                                          let address = data?.address;
                                          return (
                                            <div
                                              key={i}
                                              className="padding8 row"
                                              onClick={() => {
                                                // setcityId1(data?.cityName);
                                                setColor1(i);
                                                setDisplay1(false);
                                                //setUserId(data?.User?.userId);
                                                setFieldValue(
                                                  "sourceAddress",
                                                  city
                                                );
                                                setTimeout(() =>
                                                  setFieldTouched(
                                                    "sourceAddress",
                                                    true
                                                  )
                                                );
                                                //setUserId(data?.User?.userId);
                                                setFieldValue(
                                                  "source",
                                                  data?.addressId
                                                );
                                                setTimeout(() =>
                                                  setFieldTouched(
                                                    "source",
                                                    true
                                                  )
                                                );
                                              }}
                                            >
                                              {color1 === i ? (
                                                <div className="col-1">
                                                  <SvgImage name="SelectedRadio" />
                                                </div>
                                              ) : (
                                                <div className="col-1">
                                                  <SvgImage name="UnselectedRadio" />
                                                </div>
                                              )}
                                              {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                              <div
                                                className="col-11"
                                                style={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                {city} - {address}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </>
                                    )}
                                    {savedAddresses?.length == 0 ? (
                                      <div className="">
                                        <div style={{ margin: "24px" }}>
                                          You have no addresses to select please
                                          add a new one
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div style={{ color: "red" }}>
                                {errors.sourceAddress &&
                                touched.sourceAddress ? (
                                  <div>*{errors.sourceAddress}</div>
                                ) : null}
                              </div>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                wordBreak: "break-all",
                              }}
                            >
                              {/* {elem?.toAddress?.cityName} */}
                              <input
                                type="text"
                                className="minBox3"
                                name="destAddress"
                                value={values?.destAddress || ""}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)
                                  setFieldValue(
                                    "destAddress",
                                    event.target.value,
                                    true
                                  );

                                  setDisplay2(true);
                                  setSearch2(event.target.value);
                                }}
                                onClick={() => {
                                  setDisplay2(true);
                                }}
                              />
                              {display2 ? (
                                <div
                                  className="padding16 newCashback whiteBackground"
                                  style={{
                                    position: "absolute",
                                    width: "350px",
                                    height: "275px",
                                    zIndex: "90",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      setDisplay2(false);
                                      // setSearch2("");
                                      //dispatch(clearAllDriversByVrn());
                                      // setFieldValue("destAddress", "", true);
                                    }}
                                    style={{
                                      position: "absolute",
                                      right: "0.5rem",
                                      top: "0.5rem",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <SvgImage name="CloseButtonLogo" />
                                  </div>
                                  <div
                                    style={{
                                      overflowY: "scroll",
                                      overflowX: "hidden",
                                      height: "240px",
                                    }}
                                  >
                                    {search2 == "" ? (
                                      savedAddresses?.map((data, i) => {
                                        let city = data?.cityName;
                                        let state = data?.stateName;
                                        let address = data?.address;
                                        return (
                                          <div
                                            key={i}
                                            className="padding8 row"
                                            onClick={() => {
                                              // setcityId2(data?.cityName);
                                              setColor2(i);
                                              setDisplay2(false);
                                              //setUserId(data?.User?.userId);
                                              setFieldValue(
                                                "destAddress",
                                                data?.cityName
                                              );
                                              setTimeout(() =>
                                                setFieldTouched(
                                                  "destAddress",
                                                  true
                                                )
                                              );
                                              //setUserId(data?.User?.userId);
                                              setFieldValue(
                                                "destination",
                                                data?.addressId
                                              );
                                              setTimeout(() =>
                                                setFieldTouched(
                                                  "destination",
                                                  true
                                                )
                                              );
                                            }}
                                          >
                                            {color2 === i ? (
                                              <div className="col-1">
                                                <SvgImage name="SelectedRadio" />
                                              </div>
                                            ) : (
                                              <div className="col-1">
                                                <SvgImage name="UnselectedRadio" />
                                              </div>
                                            )}
                                            {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                            <div
                                              className="col-11"
                                              style={{ textAlign: "left" }}
                                            >
                                              {city} - {address}
                                            </div>
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <>
                                        {savedAddresses?.map((data, i) => {
                                          let city = data?.cityName;
                                          let state = data?.stateName;
                                          let address = data?.address;
                                          console.log(
                                            "savedAddresses",
                                            city,
                                            state,
                                            address
                                          );
                                          return (
                                            <div
                                              key={i}
                                              className="padding8 row"
                                              onClick={() => {
                                                // setcityId2(data?.cityName);
                                                setColor2(i);
                                                setDisplay2(false);
                                                //setUserId(data?.User?.userId);
                                                setFieldValue(
                                                  "destAddress",
                                                  data?.cityName
                                                );
                                                setTimeout(() =>
                                                  setFieldTouched(
                                                    "destAddress",
                                                    true
                                                  )
                                                );
                                                //setUserId(data?.User?.userId);
                                                setFieldValue(
                                                  "destination",
                                                  data?.addressId
                                                );
                                                setTimeout(() =>
                                                  setFieldTouched(
                                                    "destination",
                                                    true
                                                  )
                                                );
                                              }}
                                            >
                                              {color2 === i ? (
                                                <div className="col-1">
                                                  <SvgImage name="SelectedRadio" />
                                                </div>
                                              ) : (
                                                <div className="col-1">
                                                  <SvgImage name="UnselectedRadio" />
                                                </div>
                                              )}
                                              <div
                                                className="col-11"
                                                style={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                {city} - {address}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </>
                                    )}
                                    {savedAddresses?.length == 0 ? (
                                      <div className="">
                                        <div style={{ margin: "24px" }}>
                                          You have no addresses to select please
                                          add a new one
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div style={{ color: "red" }}>
                                {errors.destAddress && touched.destAddress ? (
                                  <div>*{errors.destAddress}</div>
                                ) : null}
                              </div>
                            </td>
                            <td style={{ width: "25%" }}>
                              {/* {elem?.startDate} */}
                              <input
                                type="datetime-local"
                                className="minBox3"
                                name="startDate"
                                value={values?.startDate || ""}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)
                                  setFieldValue(
                                    "startDate",
                                    event.target.value,
                                    false
                                  );
                                }}
                              />
                            </td>
                            <td style={{ width: "20%" }}>
                              {/* {elem?.freightAmount} */}
                              <input
                                type="number"
                                className="minBox3"
                                name="freightAmount"
                                autoComplete={"off"}
                                value={values?.freightAmount || ""}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)
                                  setFieldValue(
                                    "freightAmount",
                                    event.target.value,
                                    false
                                  );
                                }}
                              />
                            </td>
                            <td style={{ width: "20%" }}>
                              {/* {elem?.weight} */}
                              <input
                                type="number"
                                className="minBox3"
                                name="weight"
                                autoComplete={"off"}
                                value={values?.weight || ""}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)
                                  setFieldValue(
                                    "weight",
                                    event.target.value,
                                    false
                                  );
                                }}
                              />
                            </td>
                            <td style={{ width: "20%" }}>
                              {/* {payBy} */}
                              <input
                                type="text"
                                className="minBox3"
                                name="customerName"
                                autoComplete={"off"}
                                value={values?.customerName || ""}
                                onClick={() => {
                                  setCustomerOpen(true);
                                }}
                                onChange={(event) => {
                                  // handleChangeFieldCharges(index, e)
                                  setSearchCustomer(event.target.value);
                                  setFieldValue(
                                    "customerName",
                                    event.target.value,
                                    false
                                  );
                                  setFieldValue(
                                    "consignorName",
                                    event.target.value,
                                    false
                                  );
                                }}
                              />
                              <div style={{ position: "relative" }}>
                                {customerOpen ? (
                                  <div className="driverSearchContainer2 containerShadow">
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "0.3rem",
                                        right: "0.3rem",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setCustomerOpen(false);
                                      }}
                                    >
                                      <SvgImage name="CloseButtonLogo" />
                                    </div>
                                    {customerList?.map((item, i) => {
                                      console.log("itemcustomerList", item);
                                      return (
                                        <>
                                          {/* {item?.Fastag !== null ? ( */}
                                          <div
                                            key={i}
                                            className="flexStyling padding8"
                                            onClick={(event) => {
                                              setCustomerOpen(false);
                                              // setUserId(event.target.value);
                                              setFieldValue(
                                                "customerName",
                                                item?.companyName,
                                                true
                                              );
                                              setFieldValue(
                                                "customerId",
                                                item?.customerId,
                                                true
                                              );
                                              setFieldValue(
                                                "consignorName",
                                                item?.companyName,
                                                true
                                              );
                                              setFieldValue(
                                                "consignorId",
                                                item?.customerId,
                                                true
                                              );
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              name="consignorName"
                                              value={item?.customerId}
                                              id={item?.customerId}
                                              autoComplete={"off"}
                                            />
                                            <div
                                              className="padding16L"
                                              value={item?.customerId}
                                            >
                                              {item?.companyName}
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}

                                    {customerCount == 0 ? (
                                      <div className="heading3 semiBold padding16 padding24B">
                                        No Customer Available
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                ) : (
                                  <></>
                                )}

                                <div style={{ color: "red" }}>
                                  {errors.customerId && touched.customerId ? (
                                    <div>*{errors.customerId}</div>
                                  ) : null}
                                </div>
                              </div>
                            </td>
                            <td style={{ width: "20%" }}>
                              {/* <button 
                        style={{width: "60px", height:"25px",borderRadius: "5px",backgroundColor: "#FFF",borderColor: "#2E7C7B",}}
                        onClick={() => {
                          console.log("onClickonClickonClick")
                          setIsOpen(!isOpen)}}
                      >
                      <text>View</text>
                      </button> */}
                              <button
                                style={{
                                  // width: "60px",
                                  // height: "25px",
                                  borderRadius: "5px",
                                  backgroundColor: "#FFF",
                                  borderColor: "#e9e9e9",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  // setFreightNo(i);
                                  setView(false);
                                }}
                              >
                                <SvgImage
                                  name="AddAttachment"
                                  height="20"
                                  width="20"
                                />
                                <div style={{ marginLeft: "6px" }}>POD</div>
                              </button>
                            </td>
                          </div>
                          {/* }
                            open={true}
                            // triggerSibling="hskdg shkdg"
                            // onOpening={}
                          > */}
                          <div style={{ margin: "10px" }}>
                            {/* <FreightRender elem={elem} i={i} /> */}

                            <div style={{ marginTop: "2px" }}>
                              {/* {freightNo === i ? ( */}
                              <FreightUpdateRender
                                create={true}
                                freight={values}
                                view={false}
                                tripId={tripData?.tripId}
                                setNewFreight={setNewFreight}
                              />
                              {/* ) : (
                                  <></>
                                )} */}
                            </div>
                          </div>
                          {/* </Collapsible> */}
                        </div>
                      </Form>
                    )}
                  </Formik>
                ) : null}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginRight: "24px",
                  }}
                >
                  <button
                    style={{
                      // width: "60px",
                      // height: "25px",
                      borderRadius: "5px",
                      backgroundColor: "#FFF",
                      borderColor: "#e9e9e9",
                      alignItems: "center",
                      display: "flex",
                    }}
                    onClick={() => {
                      // setFreightNo(i);
                      setNewFreight(!newFreight);
                    }}
                  >
                    <SvgImage name="AddAttachment" height="20" width="20" />
                    <div style={{ marginLeft: "6px" }}> Add Pod</div>
                  </button>
                </div>
              </div>
            )}
            <div
              style={{
                textAlign: "center",
                display: !openEndTripModal2 ? "block" : "none",
              }}
            >
              <button
                // className="btn-edit-details"
                // style={{ marginLeft: "20px" }}
                style={{
                  width: "200px",
                  marginTop: "25px",
                }}
                className="generateOtp text3 Medium btn btn-secondary"
                onClick={() => {
                  setOpenEndTripModal2(!openEndTripModal2);
                }}
              >
                <text style={{ color: "white" }}>
                  {openEndTripModal2 ? "Previous" : "Next"}
                </text>
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* {
        console.log("ppooppooppooppooppooppooppooppoopp",toastObject.toastStatus && location == "/trips/" )
      } */}
      {/* {toastObject.toastStatus && location == "/trips/" ? (
        <Toast
          success={toastObject?.status}
          message={toastObject?.message}
          isOpen={toastObject?.toastStatus}
          toggleModal={() => {
            dispatch(
              toastStatus({
                toastStatus: false,
              })
            );
            handleClose();
            dispatch(
              getTripExpenseAction({ tripId: tripData?.tripId }, (res) => {
                console.log("getTripExpenseAction", res?.data?.data);
                if (res?.data == 200) {
                  storeDataToAsyncStorage("row", res?.data?.data?.tripData);
                  setItemTemp(res?.data?.data?.tripData);
                }
              })
            );
            setItemTemp();
            console.log("nmnnnnnnnnnmmmmppppppp", toastObject?.message);
          }}
          handleClose={()=>{
            dispatch(
              toastStatus({
                toastStatus: false,
              })
            );
            handleClose();
            dispatch(
              getTripExpenseAction({ tripId: tripData?.tripId }, (res) => {
                console.log("getTripExpenseAction", res?.data?.data);
                if (res?.data == 200) {
                  storeDataToAsyncStorage("row", res?.data?.data?.tripData);
                  setItemTemp(res?.data?.data?.tripData);
                }
              })
            );
            setItemTemp();
          }}
        />
      ) : (
        <></>
      )} */}
      <ManageDriverAddNewExpense
        userId={tripData?.userId}
        setDisplayName={"Add Expense"}
        displayName={"Add Expense"}
        open={openAddExpanse}
        toggleModal={toggleAddExpense}
        title="Logipe Account"
        handleClose={closeAddExpense}
        trip={true}
        itemTemp={tripData}
        color={"title-color2"}
      />
      <ManageDriverAddBalance
        open={open3}
        toggleModal={toggleModal3}
        remarks={`Paid for Trip ${tripData?.tripNo}`}
        title="Logipe Account"
        handleClose={handleClose3}
        color={"title-color2"}
        name="Add Balance"
        userId={tripData?.userId}
        cardType={tripData?.cardType}
        trip={true}
        driverName={tripData?.User?.fullName}
        itemTemp={tripData}
      />
      <RechargeFastagButttonModal
        open={open4}
        handleClose={handleClose4}
        toggleModal={toggleModal4}
        balance={fastagWalletAmount}
        no={tripData?.Fleet?.regNumber}
        fleetId={tripData?.fleetId}
        trip={true}
        itemTemp={tripData}
      />
      <OMCLoadModal
        userId={tripData?.userId}
        open={openFuel}
        toggleModal={toggleModalFuel}
        handleClose={handleCloseFuel}
        fleetId={tripData?.fleetId}
        trip={1}
      />
      <ChooseMethodModal
        tripData={tripData}
        open={openChooseMethod}
        toggleModal={toggleChooseModal}
        handleClose={handleChooseModal}
        handleCashPayment={addExpense}
        handleCardPayment={rechargeCard}
      />
    </div>
  );
}

export default EndTripModal;
